/**
 * Etapas del paciente (seguimiento de cobros): el backend sella
 * funnel_presupuesto_at / funnel_reserva_at / funnel_operado_at de forma
 * automática. La etiqueta visible es la etapa más avanzada alcanzada.
 *
 * «Operado» es un dato CLÍNICO, no de dinero (23/9/2026): lo sella el
 * quirófano al marcar la cita realizada. A enfermería ya no le llega ningún
 * `funnel_*` (D2, «enfermería no necesita cobros»), así que el servidor le
 * manda `operado: true/false` (patients_router.ficha_sin_el_dinero_ajeno) y
 * la insignia sale también de ahí.
 */
export function estadoFunnel(p) {
  if (!p) return null;
  if (p.funnel_operado_at || p.operado === true) {
    return { key: 'operado', label: 'Operado', cls: 'bg-emerald-600 text-white border-emerald-700' };
  }
  if (p.funnel_reserva_at) {
    return { key: 'reserva', label: 'Reserva pagada', cls: 'bg-sky-600 text-white border-sky-700' };
  }
  if (p.funnel_presupuesto_at) {
    return { key: 'presupuesto', label: 'Presupuesto entregado', cls: 'bg-amber-500 text-white border-amber-600' };
  }
  return null;
}
